// Shared category data for all components
export const categoriesData = [
  {
    id: 1,
    name: "Sports Apparel",
    image: "sportswear.jpg",
    slug: "sports-apparel",
    placeholder: "https://images.unsplash.com/photo-1607962837359-5e7e89f86776?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
    isHomeCategory: true,
    subcategories: [
      { id: 101, name: "T-Shirts", slug: "t-shirts", image: "tshirts.jpg" },
      { id: 102, name: "Shorts", slug: "shorts", image: "shorts.jpg" },
      { id: 103, name: "Jerseys", slug: "jerseys", image: "jerseys.jpg" },
      { id: 104, name: "Track Suits", slug: "track-suits", image: "tracksuits.jpg" },
      { id: 105, name: "Polo Shirts", slug: "polo-shirts", image: "polo.jpg" },
      { id: 106, name: "Hoodies", slug: "hoodies", image: "hoodies.jpg" },
      { id: 107, name: "Sweatshirts", slug: "sweatshirts", image: "sweatshirts.jpg" }
    ]
  },
  {
    id: 2,
    name: "Footwear",
    image: "footwear.jpg", 
    slug: "footwear",
    placeholder: "https://images.unsplash.com/photo-1543508282-6319a3e2621f?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
    isHomeCategory: true,
    subcategories: [
      { id: 201, name: "Running Shoes", slug: "running-shoes", image: "running.jpg" },
      { id: 202, name: "Football Boots", slug: "football-boots", image: "football.jpg" },
      { id: 203, name: "Basketball Shoes", slug: "basketball-shoes", image: "basketball.jpg" },
      { id: 204, name: "Tennis Shoes", slug: "tennis-shoes", image: "tennis.jpg" },
      { id: 205, name: "Cricket Shoes", slug: "cricket-shoes", image: "cricket.jpg" },
      { id: 206, name: "Casual Sneakers", slug: "casual-sneakers", image: "casual.jpg" },
      { id: 207, name: "Training Shoes", slug: "training-shoes", image: "training.jpg" }
    ]
  },
  {
    id: 3,
    name: "Equipment",
    image: "equipment.jpg",
    slug: "equipment",
    placeholder: "https://images.unsplash.com/photo-1584735935682-2f2b69dff9d2?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
    isHomeCategory: true,
    subcategories: [
      { id: 301, name: "Cricket Bats", slug: "cricket-bats", image: "bats.jpg" },
      { id: 302, name: "Cricket Balls", slug: "cricket-balls", image: "balls.jpg" },
      { id: 303, name: "Football", slug: "football", image: "football.jpg" },
      { id: 304, name: "Basketball", slug: "basketball", image: "basketball.jpg" },
      { id: 305, name: "Tennis Rackets", slug: "tennis-rackets", image: "rackets.jpg" },
      { id: 306, name: "Gym Equipment", slug: "gym-equipment", image: "gym.jpg" },
      { id: 307, name: "Swimming Gear", slug: "swimming-gear", image: "swimming.jpg" }
    ]
  },
  {
    id: 4,
    name: "Accessories",
    image: "accessories.jpg",
    slug: "accessories",
    placeholder: "https://images.unsplash.com/photo-1562771379-eafdca7a02f8?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
    isHomeCategory: true,
    subcategories: [
      { id: 401, name: "Cricket Bags", slug: "cricket-bags", image: "bags.jpg" },
      { id: 402, name: "Gloves", slug: "gloves", image: "gloves.jpg" },
      { id: 403, name: "Caps & Hats", slug: "caps-hats", image: "caps.jpg" },
      { id: 404, name: "Sunglasses", slug: "sunglasses", image: "sunglasses.jpg" },
      { id: 405, name: "Sports Watches", slug: "sports-watches", image: "watches.jpg" },
      { id: 406, name: "Water Bottles", slug: "water-bottles", image: "bottles.jpg" },
      { id: 407, name: "Wristbands", slug: "wristbands", image: "wristbands.jpg" }
    ]
  },
  {
    id: 5,
    name: "Supplements",
    image: "supplements.jpg",
    slug: "supplements",
    placeholder: "https://images.unsplash.com/photo-1610725663727-08695a1ac3ff?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
    isHomeCategory: true,
    subcategories: [
      { id: 501, name: "Protein Powder", slug: "protein-powder", image: "protein.jpg" },
      { id: 502, name: "Pre-Workout", slug: "pre-workout", image: "preworkout.jpg" },
      { id: 503, name: "Vitamins", slug: "vitamins", image: "vitamins.jpg" },
      { id: 504, name: "Energy Bars", slug: "energy-bars", image: "bars.jpg" },
      { id: 505, name: "Recovery Drinks", slug: "recovery-drinks", image: "recovery.jpg" },
      { id: 506, name: "Mass Gainers", slug: "mass-gainers", image: "mass.jpg" },
      { id: 507, name: "BCAA", slug: "bcaa", image: "bcaa.jpg" }
    ]
  },
  {
    id: 6,
    name: "Team Wear",
    image: "teamwear.jpg",
    slug: "team-wear",
    placeholder: "https://images.unsplash.com/photo-1517466787929-bc90951d0974?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
    isHomeCategory: true,
    subcategories: [
      { id: 601, name: "Cricket Uniforms", slug: "cricket-uniforms", image: "uniforms.jpg" },
      { id: 602, name: "Football Kits", slug: "football-kits", image: "kits.jpg" },
      { id: 603, name: "Basketball Uniforms", slug: "basketball-uniforms", image: "bb-uniforms.jpg" },
      { id: 604, name: "Custom Jerseys", slug: "custom-jerseys", image: "custom.jpg" },
      { id: 605, name: "Training Bibs", slug: "training-bibs", image: "bibs.jpg" },
      { id: 606, name: "Team Tracksuits", slug: "team-tracksuits", image: "team-track.jpg" }
    ]
  },
  {
    id: 7,
    name: "Sale",
    image: "sale.jpg",
    slug: "sale",
    placeholder: "https://images.unsplash.com/photo-1607082350899-7e105aa886ae?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
    isHomeCategory: true,
    subcategories: [
      { id: 701, name: "Clearance Items", slug: "clearance-items", image: "clearance.jpg" },
      { id: 702, name: "End of Season", slug: "end-of-season", image: "season.jpg" },
      { id: 703, name: "Outlet Deals", slug: "outlet-deals", image: "outlet.jpg" },
      { id: 704, name: "Flash Sale", slug: "flash-sale", image: "flash.jpg" },
      { id: 705, name: "Bundle Offers", slug: "bundle-offers", image: "bundle.jpg" }
    ]
  },
  {
    id: 8,
    name: "New Releases",
    image: "new.jpg",
    slug: "new-releases",
    placeholder: "https://images.unsplash.com/photo-1602211844066-d3bb556e983b?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
    isHomeCategory: true,
    subcategories: [
      { id: 801, name: "Latest Footwear", slug: "latest-footwear", image: "new-shoes.jpg" },
      { id: 802, name: "New Apparel", slug: "new-apparel", image: "new-clothes.jpg" },
      { id: 803, name: "Latest Equipment", slug: "latest-equipment", image: "new-equipment.jpg" },
      { id: 804, name: "New Accessories", slug: "new-accessories", image: "new-acc.jpg" },
      { id: 805, name: "Fresh Arrivals", slug: "fresh-arrivals", image: "fresh.jpg" }
    ]
  },
  // Additional categories for complete category list
  {
    id: 9,
    name: "Fitness",
    image: "fitness.jpg",
    slug: "fitness",
    placeholder: "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
    isHomeCategory: true,
    subcategories: [
      { id: 901, name: "Yoga Mats", slug: "yoga-mats", image: "mats.jpg" },
      { id: 902, name: "Resistance Bands", slug: "resistance-bands", image: "bands.jpg" },
      { id: 903, name: "Dumbbells", slug: "dumbbells", image: "dumbbells.jpg" },
      { id: 904, name: "Kettlebells", slug: "kettlebells", image: "kettlebells.jpg" },
      { id: 905, name: "Exercise Bikes", slug: "exercise-bikes", image: "bikes.jpg" },
      { id: 906, name: "Treadmills", slug: "treadmills", image: "treadmills.jpg" }
    ]
  },
  {
    id: 10,
    name: "Nutrition",
    image: "nutrition.jpg",
    slug: "nutrition",
    placeholder: "https://images.unsplash.com/photo-1532550907401-a500c9a57435?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
    isHomeCategory: true,
    subcategories: [
      { id: 1001, name: "Health Drinks", slug: "health-drinks", image: "drinks.jpg" },
      { id: 1002, name: "Organic Foods", slug: "organic-foods", image: "organic.jpg" },
      { id: 1003, name: "Meal Replacements", slug: "meal-replacements", image: "meals.jpg" },
      { id: 1004, name: "Sports Nutrition", slug: "sports-nutrition", image: "sports-nutrition.jpg" }
    ]
  },
  {
    id: 11,
    name: "Training",
    image: "training.jpg",
    slug: "training",
    placeholder: "https://images.unsplash.com/photo-1517838277536-f5f99be501cd?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
    isHomeCategory: true,
    subcategories: [
      { id: 1101, name: "Personal Training", slug: "personal-training", image: "personal.jpg" },
      { id: 1102, name: "Group Classes", slug: "group-classes", image: "group.jpg" },
      { id: 1103, name: "Online Coaching", slug: "online-coaching", image: "coaching.jpg" },
      { id: 1104, name: "Training Plans", slug: "training-plans", image: "plans.jpg" }
    ]
  },
  {
    id: 12,
    name: "Yoga",
    image: "yoga.jpg",
    slug: "yoga",
    placeholder: "https://images.unsplash.com/photo-1517466787929-bc90951d0974?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
    isHomeCategory: true,
    subcategories: [
      { id: 1201, name: "Yoga Mats", slug: "yoga-mats-special", image: "yoga-mats.jpg" },
      { id: 1202, name: "Yoga Blocks", slug: "yoga-blocks", image: "blocks.jpg" },
      { id: 1203, name: "Yoga Straps", slug: "yoga-straps", image: "straps.jpg" },
      { id: 1204, name: "Meditation Cushions", slug: "meditation-cushions", image: "cushions.jpg" },
      { id: 1205, name: "Yoga Apparel", slug: "yoga-apparel", image: "yoga-clothes.jpg" }
    ]
  },
  // Additional 4 categories to make total 16 categories
  {
    id: 13,
    name: "Outdoor Sports",
    image: "outdoor.jpg",
    slug: "outdoor-sports",
    placeholder: "https://images.unsplash.com/photo-1551698618-1dfe5d97d256?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
    isHomeCategory: true,
    subcategories: [
      { id: 1301, name: "Camping Gear", slug: "camping-gear", image: "camping.jpg" },
      { id: 1302, name: "Hiking Equipment", slug: "hiking-equipment", image: "hiking.jpg" },
      { id: 1303, name: "Cycling Gear", slug: "cycling-gear", image: "cycling.jpg" },
      { id: 1304, name: "Rock Climbing", slug: "rock-climbing", image: "climbing.jpg" },
      { id: 1305, name: "Water Sports", slug: "water-sports", image: "water.jpg" }
    ]
  },
  {
    id: 14,
    name: "Recovery",
    image: "recovery.jpg",
    slug: "recovery",
    placeholder: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
    isHomeCategory: true,
    subcategories: [
      { id: 1401, name: "Massage Tools", slug: "massage-tools", image: "massage.jpg" },
      { id: 1402, name: "Foam Rollers", slug: "foam-rollers", image: "rollers.jpg" },
      { id: 1403, name: "Compression Wear", slug: "compression-wear", image: "compression.jpg" },
      { id: 1404, name: "Ice Packs", slug: "ice-packs", image: "ice.jpg" },
      { id: 1405, name: "Recovery Drinks", slug: "recovery-drinks-special", image: "recovery-drinks.jpg" }
    ]
  },
  {
    id: 15,
    name: "Kids Sports",
    image: "kids.jpg",
    slug: "kids-sports",
    placeholder: "https://images.unsplash.com/photo-1551698618-1dfe5d97d256?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
    isHomeCategory: true,
    subcategories: [
      { id: 1501, name: "Kids Footwear", slug: "kids-footwear", image: "kids-shoes.jpg" },
      { id: 1502, name: "Kids Apparel", slug: "kids-apparel", image: "kids-clothes.jpg" },
      { id: 1503, name: "Junior Equipment", slug: "junior-equipment", image: "junior-gear.jpg" },
      { id: 1504, name: "School Sports", slug: "school-sports", image: "school.jpg" },
      { id: 1505, name: "Kids Accessories", slug: "kids-accessories", image: "kids-acc.jpg" }
    ]
  },
  {
    id: 16,
    name: "Technology",
    image: "technology.jpg",
    slug: "technology",
    placeholder: "https://images.unsplash.com/photo-1518611012118-696072aa579a?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
    isHomeCategory: true,
    subcategories: [
      { id: 1601, name: "Fitness Trackers", slug: "fitness-trackers", image: "trackers.jpg" },
      { id: 1602, name: "Smart Watches", slug: "smart-watches", image: "smart-watches.jpg" },
      { id: 1603, name: "Headphones", slug: "headphones", image: "headphones.jpg" },
      { id: 1604, name: "Action Cameras", slug: "action-cameras", image: "cameras.jpg" },
      { id: 1605, name: "Sports Apps", slug: "sports-apps", image: "apps.jpg" }
    ]
  },
  // Additional categories for "All Categories" page only (not shown on home page)
  {
    id: 17,
    name: "Winter Sports",
    image: "winter-sports.jpg",
    slug: "winter-sports",
    placeholder: "https://images.unsplash.com/photo-1551698618-1dfe5d97d256?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
    isHomeCategory: false,
    subcategories: [
      { id: 1701, name: "Ski Equipment", slug: "ski-equipment", image: "ski.jpg" },
      { id: 1702, name: "Snowboard Gear", slug: "snowboard-gear", image: "snowboard.jpg" },
      { id: 1703, name: "Winter Apparel", slug: "winter-apparel", image: "winter-clothes.jpg" },
      { id: 1704, name: "Ice Skating", slug: "ice-skating", image: "ice-skating.jpg" },
      { id: 1705, name: "Winter Accessories", slug: "winter-accessories", image: "winter-acc.jpg" }
    ]
  },
  {
    id: 18,
    name: "Water Sports",
    image: "water-sports.jpg",
    slug: "water-sports-detailed",
    placeholder: "https://images.unsplash.com/photo-1530549387789-4c1017266635?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
    isHomeCategory: false,
    subcategories: [
      { id: 1801, name: "Swimming Gear", slug: "swimming-gear-pro", image: "swimming-pro.jpg" },
      { id: 1802, name: "Surfing Equipment", slug: "surfing-equipment", image: "surfing.jpg" },
      { id: 1803, name: "Diving Gear", slug: "diving-gear", image: "diving.jpg" },
      { id: 1804, name: "Water Safety", slug: "water-safety", image: "water-safety.jpg" },
      { id: 1805, name: "Boat Sports", slug: "boat-sports", image: "boat.jpg" }
    ]
  },
  {
    id: 19,
    name: "Combat Sports",
    image: "combat-sports.jpg",
    slug: "combat-sports",
    placeholder: "https://images.unsplash.com/photo-1594736797933-d0501ba2fe65?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
    isHomeCategory: false,
    subcategories: [
      { id: 1901, name: "Boxing Equipment", slug: "boxing-equipment", image: "boxing.jpg" },
      { id: 1902, name: "MMA Gear", slug: "mma-gear", image: "mma.jpg" },
      { id: 1903, name: "Martial Arts", slug: "martial-arts", image: "martial-arts.jpg" },
      { id: 1904, name: "Wrestling Gear", slug: "wrestling-gear", image: "wrestling.jpg" },
      { id: 1905, name: "Protective Gear", slug: "protective-gear", image: "protection.jpg" }
    ]
  },
  {
    id: 20,
    name: "Women's Sports",
    image: "womens-sports.jpg",
    slug: "womens-sports",
    placeholder: "https://images.unsplash.com/photo-1594736797933-d0501ba2fe65?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
    isHomeCategory: false,
    subcategories: [
      { id: 2001, name: "Women's Activewear", slug: "womens-activewear", image: "womens-activewear.jpg" },
      { id: 2002, name: "Women's Footwear", slug: "womens-footwear", image: "womens-shoes.jpg" },
      { id: 2003, name: "Women's Equipment", slug: "womens-equipment", image: "womens-equipment.jpg" },
      { id: 2004, name: "Women's Accessories", slug: "womens-accessories", image: "womens-accessories.jpg" },
      { id: 2005, name: "Maternity Sportswear", slug: "maternity-sportswear", image: "maternity.jpg" }
    ]
  },
  {
    id: 21,
    name: "Athletic Performance",
    image: "performance.jpg",
    slug: "athletic-performance",
    placeholder: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
    isHomeCategory: false,
    subcategories: [
      { id: 2101, name: "Performance Monitoring", slug: "performance-monitoring", image: "monitoring.jpg" },
      { id: 2102, name: "Speed Training", slug: "speed-training", image: "speed.jpg" },
      { id: 2103, name: "Agility Equipment", slug: "agility-equipment", image: "agility.jpg" },
      { id: 2104, name: "Strength Training", slug: "strength-training", image: "strength.jpg" },
      { id: 2105, name: "Endurance Gear", slug: "endurance-gear", image: "endurance.jpg" }
    ]
  },
  {
    id: 22,
    name: "Team Management",
    image: "team-management.jpg",
    slug: "team-management",
    placeholder: "https://images.unsplash.com/photo-1517466787929-bc90951d0974?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
    isHomeCategory: false,
    subcategories: [
      { id: 2201, name: "Coaching Tools", slug: "coaching-tools", image: "coaching.jpg" },
      { id: 2202, name: "Team Communication", slug: "team-communication", image: "communication.jpg" },
      { id: 2203, name: "Event Management", slug: "event-management", image: "events.jpg" },
      { id: 2204, name: "Tournament Gear", slug: "tournament-gear", image: "tournament.jpg" },
      { id: 2205, name: "Referee Equipment", slug: "referee-equipment", image: "referee.jpg" }
    ]
  },
  {
    id: 23,
    name: "Specialized Sports",
    image: "specialized-sports.jpg",
    slug: "specialized-sports",
    placeholder: "https://images.unsplash.com/photo-1551698618-1dfe5d97d256?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
    isHomeCategory: false,
    subcategories: [
      { id: 2301, name: "Archery Equipment", slug: "archery-equipment", image: "archery.jpg" },
      { id: 2302, name: "Golf Equipment", slug: "golf-equipment", image: "golf.jpg" },
      { id: 2303, name: "Equestrian Gear", slug: "equestrian-gear", image: "equestrian.jpg" },
      { id: 2304, name: "Motorsports", slug: "motorsports", image: "motorsports.jpg" },
      { id: 2305, name: "Extreme Sports", slug: "extreme-sports", image: "extreme.jpg" }
    ]
  },
  {
    id: 24,
    name: "Sports Medicine",
    image: "sports-medicine.jpg",
    slug: "sports-medicine",
    placeholder: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80",
    isHomeCategory: false,
    subcategories: [
      { id: 2401, name: "Injury Prevention", slug: "injury-prevention", image: "prevention.jpg" },
      { id: 2402, name: "Rehabilitation", slug: "rehabilitation", image: "rehab.jpg" },
      { id: 2403, name: "Physical Therapy", slug: "physical-therapy", image: "therapy.jpg" },
      { id: 2404, name: "Medical Supplies", slug: "medical-supplies", image: "medical.jpg" },
      { id: 2405, name: "First Aid", slug: "first-aid", image: "first-aid.jpg" }
    ]
  }
];

// Helper functions
export const getCategoryBySlug = (slug) => {
  return categoriesData.find(category => category.slug === slug);
};

export const getSubcategoryBySlug = (categorySlug, subcategorySlug) => {
  const category = getCategoryBySlug(categorySlug);
  if (category && category.subcategories) {
    return category.subcategories.find(sub => sub.slug === subcategorySlug);
  }
  return null;
};

export const getHomePageCategories = () => {
  // Return all 16 categories for home page carousel (8 per page, 2 pages)
  return categoriesData.filter(category => category.isHomeCategory);
};

export const getAllCategories = () => {
  return categoriesData;
}; 